module.exports = __webpack_public_path__ + "static/media/listing-icon-inactive.907c5822.svg";